import { render, staticRenderFns } from "./colorProportion.vue?vue&type=template&id=5252802c&scoped=true&"
import script from "./colorProportion.vue?vue&type=script&lang=js&"
export * from "./colorProportion.vue?vue&type=script&lang=js&"
import style0 from "./colorProportion.vue?vue&type=style&index=0&id=5252802c&scoped=true&lang=scss&"
import style1 from "./colorProportion.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5252802c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
